module.exports = __webpack_public_path__ + "static/img/demo_profile_call.f06fb9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/demo_profile_call.png
// module id = cvEW
// module chunks = 134